import { useMemo } from 'react';

import toast from 'react-hot-toast';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import deleteAlarm from 'api/user/deleteAlarm';
import fetchAlarm from 'api/user/fetchAlarm';
import updateConfirmAlarm from 'api/user/updateConfirmAlarm';
import API_END_POINT from 'constants/apiEndPoints';

const useAlarm = () => {
  const queryClient = useQueryClient();

  const { data: fetchData } = useQuery({
    queryKey: [API_END_POINT.USER.FETCH_ALARM],
    queryFn: fetchAlarm,
  });

  const confirmMutation = useMutation({
    mutationFn: updateConfirmAlarm,
    onSuccess: (data) => {
      if (data.result) {
        queryClient.setQueryData([API_END_POINT.USER.FETCH_ALARM], {
          ...fetchData,
          updatedAlarm: false,
        });
      }
    },
  });

  const deleteAlarmMutation = useMutation({
    mutationFn: deleteAlarm,
    onSuccess: (data, { id }) => {
      if (data.result) {
        const newAlarmList = { ...fetchData?.alarmList };
        delete newAlarmList[id];

        queryClient.setQueryData([API_END_POINT.USER.FETCH_ALARM], {
          ...fetchData,
          alarmList: newAlarmList,
        });
      }
    },
    onError: () => {
      toast.error('잠시 후 다시 시도해 주세요');
    },
  });

  const { isAlarmUpdated, alarms } = useMemo(() => {
    if (fetchData?.result) {
      return {
        isAlarmUpdated: fetchData.updatedAlarm,
        alarms: Object.keys(fetchData.alarmList).map((id) => ({
          ...fetchData.alarmList[id],
          id,
        })),
      };
    }

    return {
      isAlarmUpdated: false,
      alarms: [],
    };
  }, [fetchData]);

  const handleAlarmCloseClick = (id: string) => {
    deleteAlarmMutation.mutate({ id });
  };

  const handleTriggerClick = () => {
    confirmMutation.mutate();
  };

  return {
    alarms,
    isAlarmUpdated,
    handleTriggerClick,
    handleAlarmCloseClick,
  };
};

export default useAlarm;
